import SideToolbar from './side-toolbar';

export default SideToolbar;
